import { FC } from 'react'
import { getDateTimeFromUtc, getUserAvatar, useStores } from '@/utils'
import { IQuestionBase } from '@/types'
import { Avatar } from '@/components/atoms/Avatar'
import { observer } from 'mobx-react'
import Link from 'next/link'
import { QuestionTipButtonGroup } from '@/components/molecules/QuestionTipButtonGroup'
import { useWallet } from '@solana/wallet-adapter-react'
import styles from './index.module.scss'

type Props = {
  question: IQuestionBase
}

export const QuestionBoxQuestionerGroup: FC<Props> = observer(({ question }) => {
  const { viewer } = useStores()
  const { connected } = useWallet()

  return (
    <div className={styles.container}>
      <div className={styles.tips}>
        {question?.questioner?.profile?.solanaAddress &&
          viewer.isSignedIn &&
          connected &&
          question?.questioner?.username !== viewer.viewer?.username && (
            <QuestionTipButtonGroup question={question} amountOfThanks={Number(question?.amount)} />
          )}
      </div>
      <div className={styles.questionerGroup}>
        <Link href={`/users/${question?.questioner.username}`}>
          <a>
            <div className={styles.avatar}>
              <Avatar src={getUserAvatar(question?.questioner)} alt={question?.questioner.name} />
            </div>
          </a>
        </Link>
        <div>
          <div className={styles.name}>{question?.questioner.name}</div>
          <div className={styles.time}>{getDateTimeFromUtc(question?.updatedAt, 'YYYY/M/D HH:mm')}</div>
        </div>
      </div>
    </div>
  )
})
